module.exports = __webpack_public_path__ + "assets/img/guide.b8f58114.svg";